import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrRadioComponent } from './tr-radio.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [ TrRadioComponent ],
    declarations: [ TrRadioComponent ],
})
export class TrRadioModule {}
